import mainLogo from '../../images/Carrera/Carrera_vw_logo_main_wide.png';
import squareLogo from '../../images/Carrera/Carrera_logo_solo_color.png';
import mainLogoWhite from '../../images/Carrera/Carrera_logo_white.png';
import bannerLogoWhite from '../../images/Carrera/Carrera_logo_solo_white.png';
import banner01 from '../../images/Carrera/Carrera_BG_01.jpg';
import banner02 from '../../images/Carrera/Carrera_BG_02.jpg';
import banner03 from '../../images/Carrera/Carrera_BG_03.jpg';
import banner04 from '../../images/Carrera/Carrera_BG_04.jpg';
import car123 from '../../images/Carrera/123_carrera.jpg';
import box123 from '../../images/Carrera/123_jetta.jpg';
import {SliderProducts} from '../../Utilities/SliderProducts';

export const configData = {
    defaultStore: 'Carrera',
    defaultStoreLink: 'carrerapecas.com.br',
    defaultContactEmail: 'ecommercevw@carrera.com.br',
    whatsappNumber: '11 99250 3756',
    CNPJname: 'MARAZUL DISTRIBUIDORA DE VEICULOS LTDA',
    CNPJ: '19.361.558/0005-54',
    CNPJaddress: 'Alameda Araguaia, Nº 2111 - Alphaville Industrial, Barueri, São Paulo - 06455-000',
    launchDate: '01/05/2025',

    multiContact: {},
    searchByPlate: false,

    coupons: [
        // {
        //     coupon: '10PORCENTO',
        //     discountPrice: 0,
        //     discountPercent: 0.1,
        //     freeShipping: false,
        // },
        // {
        //     coupon: '10REAIS',
        //     discountPrice: 10,
        //     discountPercent: 0,
        //     freeShipping: false,
        // },
        // {
        //     coupon: 'FRETEGRATIS',
        //     discountPrice: 0,
        //     discountPercent: 0,
        //     freeShipping: true,
        // },
    ],

    brands: [
        'volkswagen',
    ],

    homologBrands: [
        'motorcraft',
        'motrio',
        'acdelco',
        'mopar',
        'bproauto',
    ],

    noVehicle: false,

    storeSellersWarehouses: [
        "CARRERA ACELERA VW",
    ],
    
    disabledSellers: [],

    useMktNames: false,

    endYear: 2025,
    startYear: 1996,

    payment: {
        maxParcels: 6,
        checkoutParcels: {
            0: 1,
            200: 2,
            300: 3,
            600: 4,
            800: 5,
            1000: 6,
        }
    },

    customShipping: {
        deliveryTime: 1,
    },

    productSlider: [
        {
            name: 'Kits',
            img: 'tabKits',
            products: SliderProducts.Kits
        },
        {
            name: 'Óleos',
            img: 'tabOleos',
            products: SliderProducts.Oleos
        },
        {
            name: 'Filtros',
            img: 'tabFiltros',
            products: SliderProducts.Filtros
        },
        {
            name: 'Acessórios',
            img: 'tabAcessorios',
            products: SliderProducts.Acessorios
            },
        {
            name: 'Roupas',
            img: 'tabRoupas',
            products: SliderProducts.Roupas
        }
    ]
}

export const contentData = {
    mainLogo: mainLogo,
    squareLogo: squareLogo,
    bannerLogoWhite: mainLogoWhite,

    banner01: banner01,
    banner02: banner02,
    banner03: banner03,
    bannerBrands: '',
    aboutUsBg: banner04,

    box123: box123,
    car123: car123,
    
    paymentImg: squareLogo,
    paymentImgMobile: squareLogo,

    bannerSpecial: '',
    bannerSpecialMobile: '',
    imgSepcial: '',
    imgSepcialMobile: '',

    bannerHighlight: 'Compre peças originais <span style="font-weight: bold;">Volkswagen</span> direto das concessionárias <span style="font-weight: bold;">Carrera</span>.',
    aboutUs: {
        title: 'Sobre nós',
        content: [
            'Somos um grupo consolidado desde 2002 iniciando as operações em parceria com a Chevrolet. Em 2014, fomos selecionados para representar a Volkswagen, e desde então não paramos de crescer! Logo em seguida permanecemos com o plano de expansão e passamos a representar também a Nissan. Nos anos seguintes não paramos de expandir também com a GWM, Bajaj e Zeekr.',
            'Atendemos os nossos clientes de forma completa, desde a compra do veículo até a realização de serviços necessários para o mesmo.',
            'Como uma das concessionárias mais renomadas do mercado e por diversas vezes sendo a número 1 na sua região, possuímos empresas parceiras ajudar nos negócios, sendo elas, uma Corretora de Seguros própria, blindadora interna e ainda contamos com uma especializada em financiamentos e documentações.',
            'Todos os departamentos são divididos entre vendas, pós vendas, administrativo, blindados e corretora! Desta forma conseguimos ter uma base completa para atingir qualquer desafio.'
        ],
        link: 'https://www.carrera.com.br/sobre',
        linkCta: 'Saiba mais',
    },

    socialMedia: {
        Instagram: 'https://www.instagram.com/grupocarrera/',
        Facebook: 'https://www.facebook.com/carrera.acelera/',
        LinkedIn: 'https://www.linkedin.com/company/grupo-carrera-veiculos/',
        Youtube: 'https://www.youtube.com/c/CarreraAcelera',
        Twitter: '',
    },

    footerContent: [],
}